@if (!hidden()) {
  @if (label(); as label) {
    <onyx-input-label
      [disabled]="disabled()"
      [required]="required() && showRequired()"
      [label]="label"
      [hint]="hint()"
      (click)="focus()"
    ></onyx-input-label>
  }

  <div
    class="tabs {{ `size-${size()}` }}"
    [class.fill]="fill()"
    [class.invalid]="isInvalid()"
    [class.disabled]="disabled()"
    (focusout)="touch.emit()"
    #containerElement
  >
    @for (tab of tabs(); track tab.value) {
      @let icon = $any(tab).icon;
      @let active = $index === activeTabIndex();
      @let isDisabled = tab.disabled ?? disabled();

      <button
        class="tab f-body-l"
        [class.active]="active"
        [class.optional]="isOptional()"
        [class.icon]="icon"
        [class.disabled]="isDisabled"
        [style.padding]="`0 ${padding()}px`"
        type="button"
        [tabindex]="isDisabled ? -1 : 0"
        [attr.data-value]="tab.value"
        [onyxTooltip]="tab.tooltip"
        (click)="changeTab($index)"
        (keydown.space)="changeTab($index)"
        #tabElement
      >
        @if (templateRef(); as templateRef) {
          <ng-container
            *ngTemplateOutlet="
              templateRef;
              context: {
                tab,
                disabled: isDisabled,
                active,
              }
            "
          ></ng-container>
        } @else {
          <div class="content">
            @if (tab.icon; as icon) {
              <div class="icon {{ disabled() ? 'gray' : tab.iconColor }}">
                <onyx-icon
                  [name]="icon.name"
                  [size]="icon.size"
                  [frame]="icon.frame"
                ></onyx-icon>

                @if (tab.iconPulse; as color) {
                  <onyx-dot
                    class="pulse-dot"
                    [color]="color"
                    [pulse]="true"
                  ></onyx-dot>
                }
              </div>
            }

            @let name = tab.name ?? '' | translate;
            @if (name) {
              <p class="name" [attr.content]="name">{{ name }}</p>
            }
          </div>
        }
      </button>
    }

    <div class="indicator" #indicatorElement></div>
  </div>

  @let control = formField() ?? formControl();
  @if (control && showErrors()) {
    <onyx-error [errors]="[control]" variant="control"></onyx-error>
  }
}
